<template>
    <f7-block class="v-cpanel-icons">
        <f7-grid no-gutter>

            <f7-col v-if="!item.items" v-for="item in items" :key="item.name" width="33" tablet-width="20">
                <a :class="'button ' + (item.color ? item.color : ' ') + (item.disable ? ' disabled' : ' ')"
                   :href="item.link"
                   @click="onClick(item)">
                    <span class="icon"></span>
                    <span class="label">{{ item.label }}</span>
                </a>
            </f7-col>
            <f7-col v-else width="33" tablet-width="20" v-for="subitem in item.items" :key="subitem.name">
                <a :class="'button ' + (subitem.color ? subitem.color : ' ') + (subitem.disable ? ' disabled' : ' ')"
                   :href="subitem.link"
                   @click="onClick(subitem)">
                    <span class="icon"></span>
                    <span class="label">{{ subitem.label }}</span>
                </a>
            </f7-col>

            <f7-col v-for="i in (Cols - (Length % Cols))" width="33" tablet-width="20" :key="i"></f7-col>

        </f7-grid>
    </f7-block>
</template>
<script>
    export default {
        data: function () {
            return {

            }
        },
        props: {
            items: Array,
        },
        computed: {
            Cols: function () {
                let self = this;

                if (self.$$(window).width() >= 768)
                    return 5;
                else
                    return 3;
            },
            Length: function () {
                let self = this;
                let ret = 0;

                self.items.forEach(function (item) {
                    if (!item.items)
                        ret++;
                    else {
                        item.items.forEach(function (item) {
                            ret++;
                        });
                    }
                });

                return ret;
            }
        },
        methods: {
            onClick: function (item) {
                if (item.onClick)
                    item.onClick();
            }
        },
        created: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// VCpanelIcons.vue?f5056b4a